import PosCartActions from "../../../../actions/PosCartActions";

class FeeDonationItem extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            uuid     : uuid(),
            show     : false
        };

        this.removeFeeDiscount = this.removeFeeDiscount.bind(this);
    }

    removeFeeDiscount(data) {
        var guest           = this.props.guest;

        PosCartActions.removeAppliedFeeDonation(guest, data)
    }

    render() {
        var fd      = this.props.fd

        return (
            <div
                className={'cart-discounts__item row'}
                id={fd.AppliedFeeDonationId}>

                <div className='cart-discounts__title col-9'>
                    {fd.Name}
                </div>
                { !fd.IsAutomatic &&
                    <div
                        className='mt-2 pull-right'
                        title='Remove Fee/Donation'
                        onClick={this.removeFeeDiscount.bind(this, fd)}>

                        <i className='fa fa-times' aria-hidden='true' />
                    </div>
                }

                <div
                    className='col-12'
                    key={fd.AppliedFeeDonationId}>


                    <div className='cart-discounts__child--title'>
                        {'$ ' + _.round(fd.CashValue, 2).toFixed(2)}
                    </div>

                </div>
            </div>
        );
    }
}

export default FeeDonationItem;


// WEBPACK FOOTER //
// ./ui_src/app/components/pos/sidebar/feesDonations/FeeDonationItem.react.jsx